'use client'

import { PersistGateProps } from 'redux-persist/integration/react'
import { PersistGate } from 'redux-persist/integration/react'
import { PropsWithChildren } from 'shared/types/PropsWithChildren'

interface SSROutsetProps extends PropsWithChildren {
  persistor: PersistGateProps['persistor']
}

export const Persist = ({ children, persistor }: SSROutsetProps) => {
  return (
    <PersistGate
      loading={null}
      persistor={persistor}
    >
      {children}
    </PersistGate>
  )
}
